// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cms-blog-footer__legal{border-bottom:thin solid rgba(206,214,219,.5);border-top:thin solid rgba(206,214,219,.5);color:#6c6a72;font-size:.75rem;line-height:1.125rem;padding:1.25rem 0}.cms-blog-footer__legal strong{color:#332a5d;font-size:.875rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
